import t from '../translate/index';

export const GRADE_COLORS = {
  A: 'var(--appleGreen)',
  B: 'var(--severityYellow)',
  C: 'var(--severityOrange)',
  D: 'var(--severityRed)',
  F: 'var(--badgeRed)',
  N_A: 'var(--timberwolf)'
};

const ACADEMIC_GRADES = Object.keys(GRADE_COLORS);

const buildOption = g => ({
  label: g === 'N_A' ? t(`score.n_a_short`) : g,
  tooltip: t(`score.${g}`),
  color: GRADE_COLORS[g]
});

// const GRADE_OPTIONS = ACADEMIC_GRADES.map(buildOption); // expose when needed as list of options
const GRADE_TO_OPTION = ACADEMIC_GRADES.reduce((acc, g) => ({ ...acc, [g]: buildOption(g) }), {});

export const mapScoreToGradeOption = score => {
  /** null / undefined */
  if (score == null) return GRADE_TO_OPTION.N_A;
  if (score > 90) return GRADE_TO_OPTION.A;
  if (score > 80) return GRADE_TO_OPTION.B;
  if (score > 70) return GRADE_TO_OPTION.C;
  if (score > 60) return GRADE_TO_OPTION.D;
  return GRADE_TO_OPTION.F;
};

export const mapScoreToGrade = score => mapScoreToGradeOption(score)?.label;
